<template>
    <Teleport to="body">
        <span class="modal-box-background"
            :class="{ mobile: data.isMobile }"
            @touchmove.prevent=""
            @click="close"></span>

        <div :class="[
                'modal-box',
                `modal-box-${data.id}`,
                (props.full ? 'full' : ''),
                (props.size ? props.size : ''),
                (data.isMobile ? 'mobile' : ''),
                (props.secondary ? 'secondary' : '')
            ]"
            ref="optionsList"
            :style="{
                width: props.width ? props.width + 'px' : '',
                transform: data.transform,
                opacity: data.opacity,
                ...(data.bottom !== null ? { bottom: data.bottom } : {})
            }"
            @touchstart="startDrag"
            @touchmove.stop="onDrag"
            @touchend="endDrag"

            v-touch:swipe.top="onSwipeTop"
            v-touch:swipe.bottom="onSwipeBottom"
            @click="click"
        >
            <slot></slot>
        </div>
    </Teleport>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { placeOptionList, isMobile } from '🔗/utils/utils.js';
import { message } from '🔗/utils/utils';
import { code, findScrollableParent } from '🔗/utils/utils';

const optionsList = ref(null);

const { t } = useI18n();

const props = defineProps({
    field: { type: [Object, null], default: null },
    full: { type: Boolean, default: false },
    draggable: { type: Boolean, default: true },
    size: { type: [String, null], default: null },
    secondary: { type: Boolean, default: false },
    width: { type: [Number, null], default: null },
    placeOptions: { type: Object, default: () => ({}) }
});

const data = reactive({
    id: code(),
    // isAtTop: true,
    // isAtBottom: false,
    isTouching: false,
    isScrolling: false,
    isMobile: isMobile(),

    transform: 'none',
    opacity: 1,
    startY: 0,
    bottom: null
});

const emit = defineEmits(['close', 'onClick', 'onSwipeTop', 'onSwipeBottom']);

const close = (e) => {
    emit('close', e);
};

const click = (e) => {
    emit('onClick', e);
};

const onSwipeTop = () => {
    if (!props.draggable) {
        return;
    }

    if (data.isScrolling) {
        return;
    }

    emit('onSwipeTop');
};

const onSwipeBottom = () => {
    if (!props.draggable) {
        return;
    }

    if (data.isScrolling) {
        return;
    }

    emit('onSwipeBottom');
};

// const handleTouchStart = () => {
//     data.isScrolling = false;
// };

// const handleScroll = () => {
//     const ul = optionsList.value.querySelector('ul');

//     if (ul) {
//         data.isAtTop = ul.scrollTop === 0;
//         data.isAtBottom = ul.scrollHeight - ul.scrollTop === ul.clientHeight;


//         if (!data.isAtTop || !data.isAtBottom) {
//             data.isScrolling = true;
//         }
//     }
// };



let scrollParent = null;
let lastY = null;

const startDrag = (e) => {
    if (!props.draggable) {
        return;
    }

    if (!data.isMobile) {
        return;
    }

    const touch = e.touches[0];
    data.startY = touch.clientY;
    // lastY = data.startY;
    data.isTouching = true;

    // есть ли у элемента свой скролл?
    scrollParent = findScrollableParent(e.target);

    // если есть — проверим, может ли он скроллиться
    if (scrollParent) {
        data.isScrolling = true;
    } else {
        data.isScrolling = false;
    }
};

const onDrag = (e) => {
    if (!props.draggable) {
        return;
    }

    if (!data.isTouching || !data.isMobile) {
        return;
    }


    const touch = e.touches[0];
    const currentY = touch.clientY;

    if (data.isScrolling) {
        const atTop = scrollParent.scrollTop === 0;
        const atBottom = scrollParent.scrollTop + scrollParent.clientHeight >= scrollParent.scrollHeight;

        if (atTop) {
            if (!data.isAtTop) {
                data.startY = currentY;
                data.isAtTop = true
                return;
            }
        } else {
            if (data.isAtTop) {
                data.isAtTop = false
            }
        }

        if (atBottom) {
            if (!data.isAtBottom) {
                data.startY = currentY;
                data.isAtBottom = true
                return;
            }
        } else {
            if (data.isAtBottom) {
                data.isAtBottom = false
            }
        }


        // if (atTop || atBottom) {
        //     console.log(atTop, atBottom);
        // }

        if (!data.isAtTop) {
            if (data.diff) {
                if (data.diff < 0) {
                    delete data.diff;
                    return
                }
            } else {
                return;
            }
        }
    }


    // return;

    // if (lastY === null) {
    //     lastY = currentY;
    //     return;
    // }

    const diff = currentY - data.startY;

    if (diff > 0 || !data.diff) {
        data.diff = diff;
    } else {
            // console.log('>>>>>', data.diff, diff);
    }
    // // если пользователь скроллит вложенный контент
    // if (scrollParent) {
    //     const atTop = scrollParent.scrollTop === 0;
    //     const atBottom = scrollParent.scrollTop + scrollParent.clientHeight >= scrollParent.scrollHeight;

    //     // если скролл может двигаться — пропускаем движение
    //     if ((diff < 0 && !atBottom) || (diff > 0 && !atTop)) {
    //         lastY = currentY;
    //         return; // не даём модалке свайпаться
    //     }

    //     // если дошли до границы — отключаем режим скролла и передаём свайп модалке
    //     data.isScrolling = false;
    //     scrollParent = null;
    //     data.startY = currentY;
    // }

    // // Если мы здесь — модалка должна свайпаться вниз
    // console.log('>>>', data.diff)
    if (data.diff <= 20) {
        data.transform = 'none';
        data.opacity = 1;
        return;
    }

    if (data.diff <= 0) {
        return;
    }

    // const delta = currentY - data.startY;


    data.transform = `translateY(${data.diff - 20}px) !important`;
    data.opacity = `${1 - (data.diff - 20) / 500} !important`;
};


// const onDrag = (e) => {
//     if (!props.draggable) {
//         return;
//     }

//     if (!data.isTouching || !data.isMobile) {
//         return;
//     }


//     const touch = e.touches[0];
//     const currentY = touch.clientY;

//     if (lastY === null) {
//         lastY = currentY;
//         return;
//     }

//     const diff = currentY - lastY;

//     // если пользователь скроллит вложенный контент
//     if (scrollParent) {
//         const atTop = scrollParent.scrollTop === 0;
//         const atBottom = scrollParent.scrollTop + scrollParent.clientHeight >= scrollParent.scrollHeight;

//         // если скролл может двигаться — пропускаем движение
//         if ((diff < 0 && !atBottom) || (diff > 0 && !atTop)) {
//             lastY = currentY;
//             return; // не даём модалке свайпаться
//         }

//         // если дошли до границы — отключаем режим скролла и передаём свайп модалке
//         data.isScrolling = false;
//         scrollParent = null;
//         data.startY = currentY;
//     }

//     // Если мы здесь — модалка должна свайпаться вниз
//     if (diff <= 0) {
//         return;
//     }

//     const delta = currentY - data.startY;

//     if (delta <= 20) {
//         return;
//     }

//     data.transform = `translateY(${delta - 20}px) !important`;
//     data.opacity = `${1 - (delta - 20) / 500} !important`;
// };


const endDrag = () => {
    if (!props.draggable) {
        return;
    }

    data.isTouching = false;
    scrollParent = null;

    data.transform = 'none';
    data.opacity = 1;

    if (data.diff > 20) {
        data.isScrolling = false;
    }

    delete data.diff;

    lastY = null;
};

const onResize = () => {
    if (/iPhone|iPad|iPod/.test(window.navigator.userAgent)) {
        data.bottom = `${ window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop + 10 }px`;
    }
}

window.visualViewport?.addEventListener('resize', onResize);

onMounted(() => {
    if (!data.isMobile) {
        if (props.field) {
            placeOptionList({
                container: props.field,
                options: `.modal-box-${ data.id }`,
                ...props.placeOptions
            });
        }

        return;
    }

    // const ul = optionsList.value?.querySelector('ul');

    // if (ul) {
    //     ul.addEventListener('scroll', handleScroll);
    //     ul.addEventListener('touchstart', handleTouchStart);
    // }

    if (data.isMobile) {
        document.querySelector('html').style['overflow-y'] = 'hidden';
    }
});

onBeforeUnmount(() => {
    if (data.isMobile) {
        document.querySelector('html').style['overflow-y'] = 'auto';
        window.visualViewport?.removeEventListener('resize', onResize);
    }
});
</script>

<style lang="scss">
.modal-box {
    display: flex;
    flex-direction: column;
    max-height: 40vh;
    z-index: 400;
    @include sub-bg;
    position: fixed;
    border-radius: 10px;
    padding: 8px 0;
    transition: transform 0.3s ease-out;
    min-width: 192px;

    &.size-xl {
        max-height: 100vh;
    }
    &.size-l {
        max-height: 80vh;
    }

    & > ul {
        list-style: none;
        padding: 0;
        cursor: pointer;
        overflow-y: auto;
        overflow-x: hidden;
        border-radius: 8px;
        margin: 2px 0 0 0;
        display: flex;
        flex-direction: column;
        gap: 0;
        flex: 1 1 100%;
        height: 1%;
        @include scrollbar(var(--white-10), var(--dark-20), 6px);

        & > li {
            display: flex;
            flex-direction: row;
            padding: 10px 20px;
            align-items: center;
            justify-content: space-between;
            font: var(--font-body-2);
            color: var(--dark-500);
            cursor: pointer;
            gap: 20px;
            min-width: 192px;
            flex-shrink: 0;

            .skeleton-wrapper {
                width: 30px;
                height: 30px;
                margin: -7px;
                border-radius: 8px;
                overflow: hidden;
            }

            svg {
                fill: var(--dark-20);
                stroke: var(--dark-80);
                flex-shrink: 0;
                width: 16px;
                height: 16px;
                flex-shrink: 0;
            }

            span {
                margin-right: auto;
            }
            &.box-input {
                position: sticky;
                top: 0;
                width: 100%;
                // background: var(--white-80);
                z-index: 1;
                .field {
                    width: 100%;
                }
            }

            &.selected {
                color: var(--primary-500);
                svg {
                    &.check {
                        fill: var(--primary-500);
                        stroke: var(--tertiary-500);
                    }
                }
            }

            a {
                font: var(--font-body-2);
                color: var(--dark-500);
            }

            &:hover {
                color: var(--primary-500);

                & > svg {
                    fill: var(--primary-500);
                    stroke: var(--tertiary-500);
                }

                & > span {
                    color: var(--primary-500);
                }
            }

            &.disabled {
                color: var(--dark-20);
                cursor: default;
                & > svg {
                    fill: var(--dark-20);
                    stroke: var(--dark-20);
                }
                & > span {
                    color: var(--dark-20);
                }
            }

            &.range-box {
                display: flex;
                flex-direction: row;
                gap: 12px;
                align-items: center;
                flex-shrink: 0;
                padding-top: 2px;
                padding-bottom: 2px;
                cursor: default;
                min-width: 260px;

                & > label {
                    width: 48px;
                    height: 28px;
                    border-radius: 10px;
                    font: var(--font-caption);
                    background: var(--light-20);
                    color: var(--dark-500);
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    padding: 0 8px;
                    user-select: none;
                    flex-shrink: 0;
                }
                & > div {
                    flex: 1 1 100%;
                    width: 1%;
                }
            }

            &.submenu {
                cursor: default;
                &:hover {
                    background: transparent;
                }
            }
        }
    }

    & > .loader {
        background-color: var(--white-500);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        border-radius: 10px;
        & > div {
            margin: auto;
            width: 120px;
            height: 50px;
            position: relative;
            overflow: hidden;
        }
    }

    & > .header {
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        min-height: 48px;
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0;
        position: relative;
        z-index: 2;
        flex-shrink: 0;

        h3 {
            margin: 0 auto;
            padding: 0 20px;
            font: var(--font-h5);
            font-weight: bold;
            color: var(--dark-500);
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        button {
            position: absolute;
            right: 10px;
            top: 10px;
            // top: 50%;
            // transform: translateY(-50%);
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 4px;
            left: 0;
            width: 100%;
            height: 16px;
            transform: translateY(100%);
            background: linear-gradient(to top, var(--white-0) 0%, var(--white-500) 100%);
            pointer-events: none;
        }
    }

    & > .content {
        padding: 0 20px 20px;
        overflow: auto;
        flex: 1 1;
        display: flex;
        flex-direction: column;
        gap: 20px;
        z-index: 1;
        @include scrollbar();
    }

    &.mobile {
        @include mobile-options-list;

        & > .header {
            &:after {
                display: none;
            }
        }

        &.secondary {
            &:before {
                z-index: 3;
            }

            & > .header {
                background: var(--white-500);
                padding-bottom: 8px;

                margin-top: -22px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                padding-top: 16px;

                &:after {
                    display: block;
                    height: 32px;
                }
            }

            & > .content {
                padding-top: 12px;
            }
        }


        & > ul {
            & > li {
                &.box-input {
                    position: sticky;
                }
            }
        }

        &.size-l {
            max-height: 80vh;
        }

        &.size-xl {
            max-height: 100vh;
        }
    }

    &.full {
        max-height: 100%;
        height: 250px;
        width: 100%;
        border-radius: 0;
        padding-top: 30px;
        animation: fade-height .2s forwards;

        @keyframes fade-height {
            0% {
                height: 250px;
                transform: translateY(50px);
            }
            100% {
                height: 2500px;
                transform: translateY(0);
            }
        }
    }
}
.direction-rtl .modal-box {
    & > ul {
        & > li {
            span {
                margin-right: 0;
                margin-left: auto;
            }
        }
    }
}
</style>
